<template>
    <v-form v-model="valid" class="simple-search ml-2 mb-2 mr-2" ref="form">
        <h1 class="title mb-2">Suche</h1>

        <v-text-field
            :value="gpnumber"
            @input="updateGp"
            :counter="10"
            :rules="gpnumberRules"
            :disabled="loading || email.length > 0"
            @keyup.enter="submit"
            label="GP-Nummer"
        ></v-text-field>

        <v-text-field
            :value="email"
            @input="updateMail"
            :rules="emailRules"
            :disabled="loading || gpnumber.length > 0"
            @keyup.enter="submit"
            label="Email-Adresse"
        ></v-text-field>

        <v-layout>
            <div class="mr-3">
                <v-btn outlined @click="submit" :disabled="!valid || loading || !dirty">
                    <v-icon class="mr-1">mdi-account-search</v-icon> Suchen
                </v-btn>
            </div>
            <div>
                <v-btn outlined @click="clear" :disabled="!dirty || loading">
                    <v-icon class="mr-1">mdi-close-circle</v-icon> Reset
                </v-btn>
            </div>
        </v-layout>
    </v-form>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SimpleSearch',
    data() {
        return {
            valid: false,
            gpnumberRules: [
                v => (v.length === 0 || (/^[0-9]{7,10}$/.test(v) && parseInt(v, 10) >= 1000000)) || 'GP-Nummer muss gültig sein.',
            ],
            emailRules: [
                // v => (/.+@.+/.test(v) || v.length === 0)
                //    || 'Email muss gültig sein.',
            ],
        };
    },
    computed: {
        dirty() {
            return this.gpnumber.length > 0 || this.email.length > 0;
        },
        ...mapState({
            loading: state => state.simpleSearch.loading,
            email: state => state.simpleSearch.email,
            gpnumber: state => state.simpleSearch.gpnumber,
        }),
    },
    methods: {
        updateMail(value) { this.$store.commit('simpleSearch/updateEmail', value); },
        updateGp(value) { this.$store.commit('simpleSearch/updateGpnumber', value); },
        submit(evt) {
            evt.preventDefault();
            if (!this.dirty || !this.valid) {
                return;
            }
            this.$store.dispatch('simpleSearch/search', {
                email: this.email,
                gpnumber: this.gpnumber,
            }).catch(() => null);
        },
        clear() {
            this.$store.commit('simpleSearch/clear');
        },
    },
};
</script>

<style scoped lang="scss">
</style>
